export enum ActionPosition {
    Float = 0,                // Boutons actions de tableaux - Bouton 'libre'. Placé sous les tableaux 
    DockedUpperLeft = 1,      // Bouton ancré dans la toolbar haut gauche
    DockedUpperRight = 2,     // haut droit
    DockedBottomLeft = 3,     // Bas, gauche <= Valeur par défaut pour les boutons actions classiques
    DockedBottomRight = 4     // Bas, droite <= Valeur par défaut pour les boutons actions des tableaux
}